<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-sidebar">
    <div
      class="left-sidebare-overlay"
      :class="[getSidebarShowStatus ? 'd-block' : '']"
      @click="toggleSidebar()"
    ></div>
    <div
      class="left-sidebar"
      :class="['left-sidebar', getSidebarShowStatus ? 'is-sidebar-open' : '']"
    >
      <div class="h-100 d-flex flex-column justify-content-between">
        <div class="">
          <button
            v-if="!getHasHeaderStatus"
            class="burger d-block d-lg-none"
            @click="toggleSidebar()"
          >
            <div class="burger-line1"></div>
            <div class="burger-line2"></div>
            <div class="burger-line3"></div>
            <div class="burger-line4"></div>
          </button>
          <div class="sidebar-brand">
            <a href="">
              <img
                src="../../assets/images/Gigawhat_Official_Logo.svg"
                class="img-fluid"
                alt=""
              />
            </a>
          </div>
          <div class="sidebar-list">
            <ul class="nav flex-column">
              <li class="nav-item">
                <b-link
                  @click="toggleSidebar()"
                  :to="{ name: 'Dashboard' }"
                  :class="[{ active: $route.name == 'Dashboard' }]"
                  class="nav-link dashboard-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.22222 12.2222H8.55556C9.22778 12.2222 9.77778 11.6722 9.77778 11V1.22222C9.77778 0.55 9.22778 0 8.55556 0H1.22222C0.55 0 0 0.55 0 1.22222V11C0 11.6722 0.55 12.2222 1.22222 12.2222ZM1.22222 22H8.55556C9.22778 22 9.77778 21.45 9.77778 20.7778V15.8889C9.77778 15.2167 9.22778 14.6667 8.55556 14.6667H1.22222C0.55 14.6667 0 15.2167 0 15.8889V20.7778C0 21.45 0.55 22 1.22222 22ZM13.4444 22H20.7778C21.45 22 22 21.45 22 20.7778V11C22 10.3278 21.45 9.77778 20.7778 9.77778H13.4444C12.7722 9.77778 12.2222 10.3278 12.2222 11V20.7778C12.2222 21.45 12.7722 22 13.4444 22ZM12.2222 1.22222V6.11111C12.2222 6.78333 12.7722 7.33333 13.4444 7.33333H20.7778C21.45 7.33333 22 6.78333 22 6.11111V1.22222C22 0.55 21.45 0 20.7778 0H13.4444C12.7722 0 12.2222 0.55 12.2222 1.22222Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("dashboard") }}</span>
                </b-link>
              </li>

              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(
                    permissionsConstants.VIEW_SIMULATION
                  ) && userInfo.clientType === 'ARTISAN'
                "
              >
                <b-link
                  :to="{ name: 'Simulations' }"
                  :class="[
                    { active: $route.path.split('/').includes('simulations') }
                  ]"
                  @click="toggleSidebar()"
                  class="nav-link simulations-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="20" height="26" viewBox="0 0 20 26" fill="none">
                      <path
                        d="M17.5 0H2.5C1.08333 0 0 1.05625 0 2.4375V23.5625C0 24.9438 1.08333 26 2.5 26H17.5C18.9167 26 20 24.9438 20 23.5625V2.4375C20 1.05625 18.9167 0 17.5 0ZM5 22.75C4.08333 22.75 3.33333 22.0187 3.33333 21.125C3.33333 20.2313 4.08333 19.5 5 19.5C5.91667 19.5 6.66667 20.2313 6.66667 21.125C6.66667 22.0187 5.91667 22.75 5 22.75ZM5 17.875C4.08333 17.875 3.33333 17.1437 3.33333 16.25C3.33333 15.3562 4.08333 14.625 5 14.625C5.91667 14.625 6.66667 15.3562 6.66667 16.25C6.66667 17.1437 5.91667 17.875 5 17.875ZM5 13C4.08333 13 3.33333 12.2688 3.33333 11.375C3.33333 10.4812 4.08333 9.75 5 9.75C5.91667 9.75 6.66667 10.4812 6.66667 11.375C6.66667 12.2688 5.91667 13 5 13ZM10 22.75C9.08333 22.75 8.33333 22.0187 8.33333 21.125C8.33333 20.2313 9.08333 19.5 10 19.5C10.9167 19.5 11.6667 20.2313 11.6667 21.125C11.6667 22.0187 10.9167 22.75 10 22.75ZM10 17.875C9.08333 17.875 8.33333 17.1437 8.33333 16.25C8.33333 15.3562 9.08333 14.625 10 14.625C10.9167 14.625 11.6667 15.3562 11.6667 16.25C11.6667 17.1437 10.9167 17.875 10 17.875ZM10 13C9.08333 13 8.33333 12.2688 8.33333 11.375C8.33333 10.4812 9.08333 9.75 10 9.75C10.9167 9.75 11.6667 10.4812 11.6667 11.375C11.6667 12.2688 10.9167 13 10 13ZM15 22.75C14.0833 22.75 13.3333 22.0187 13.3333 21.125C13.3333 20.2313 14.0833 19.5 15 19.5C15.9167 19.5 16.6667 20.2313 16.6667 21.125C16.6667 22.0187 15.9167 22.75 15 22.75ZM15 17.875C14.0833 17.875 13.3333 17.1437 13.3333 16.25C13.3333 15.3562 14.0833 14.625 15 14.625C15.9167 14.625 16.6667 15.3562 16.6667 16.25C16.6667 17.1437 15.9167 17.875 15 17.875ZM15 13C14.0833 13 13.3333 12.2688 13.3333 11.375C13.3333 10.4812 14.0833 9.75 15 9.75C15.9167 9.75 16.6667 10.4812 16.6667 11.375C16.6667 12.2688 15.9167 13 15 13ZM16.6667 7.3125C16.6667 7.8 16.3333 8.125 15.8333 8.125H4.16667C3.66667 8.125 3.33333 7.8 3.33333 7.3125V4.0625C3.33333 3.575 3.66667 3.25 4.16667 3.25H15.8333C16.3333 3.25 16.6667 3.575 16.6667 4.0625V7.3125Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("simulations") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(permissionsConstants.VIEW_PROJECT)
                "
              >
                <b-link
                  @click="toggleSidebar()"
                  :to="{ name: 'Works' }"
                  :class="[
                    { active: $route.path.split('/').includes('works') }
                  ]"
                  class="nav-link works-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="28" height="17" viewBox="0 0 28 17" fill="none">
                      <path
                        d="M26.18 12.4231C26.18 4.57692 18.9 2.61538 18.9 2.61538L16.66 6.53846V1.30769C16.66 0.523077 16.1 0 15.26 0H12.46C11.62 0 11.06 0.523077 11.06 1.30769V6.53846L8.96 2.61538C8.96 2.61538 1.68 4.57692 1.68 12.4231C1.68 12.4231 0 12.6846 0 15.6923C0 15.6923 4.2 17 14 17C23.8 17 28 15.6923 28 15.6923C27.86 12.6846 26.18 12.4231 26.18 12.4231Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("works") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(
                    permissionsConstants.VIEW_SIMULATION
                  ) && userInfo.clientType != 'ARTISAN'
                "
              >
                <b-link
                  :to="{ name: 'Simulations' }"
                  :class="[
                    { active: $route.path.split('/').includes('simulations') }
                  ]"
                  @click="toggleSidebar()"
                  class="nav-link simulations-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="20" height="26" viewBox="0 0 20 26" fill="none">
                      <path
                        d="M17.5 0H2.5C1.08333 0 0 1.05625 0 2.4375V23.5625C0 24.9438 1.08333 26 2.5 26H17.5C18.9167 26 20 24.9438 20 23.5625V2.4375C20 1.05625 18.9167 0 17.5 0ZM5 22.75C4.08333 22.75 3.33333 22.0187 3.33333 21.125C3.33333 20.2313 4.08333 19.5 5 19.5C5.91667 19.5 6.66667 20.2313 6.66667 21.125C6.66667 22.0187 5.91667 22.75 5 22.75ZM5 17.875C4.08333 17.875 3.33333 17.1437 3.33333 16.25C3.33333 15.3562 4.08333 14.625 5 14.625C5.91667 14.625 6.66667 15.3562 6.66667 16.25C6.66667 17.1437 5.91667 17.875 5 17.875ZM5 13C4.08333 13 3.33333 12.2688 3.33333 11.375C3.33333 10.4812 4.08333 9.75 5 9.75C5.91667 9.75 6.66667 10.4812 6.66667 11.375C6.66667 12.2688 5.91667 13 5 13ZM10 22.75C9.08333 22.75 8.33333 22.0187 8.33333 21.125C8.33333 20.2313 9.08333 19.5 10 19.5C10.9167 19.5 11.6667 20.2313 11.6667 21.125C11.6667 22.0187 10.9167 22.75 10 22.75ZM10 17.875C9.08333 17.875 8.33333 17.1437 8.33333 16.25C8.33333 15.3562 9.08333 14.625 10 14.625C10.9167 14.625 11.6667 15.3562 11.6667 16.25C11.6667 17.1437 10.9167 17.875 10 17.875ZM10 13C9.08333 13 8.33333 12.2688 8.33333 11.375C8.33333 10.4812 9.08333 9.75 10 9.75C10.9167 9.75 11.6667 10.4812 11.6667 11.375C11.6667 12.2688 10.9167 13 10 13ZM15 22.75C14.0833 22.75 13.3333 22.0187 13.3333 21.125C13.3333 20.2313 14.0833 19.5 15 19.5C15.9167 19.5 16.6667 20.2313 16.6667 21.125C16.6667 22.0187 15.9167 22.75 15 22.75ZM15 17.875C14.0833 17.875 13.3333 17.1437 13.3333 16.25C13.3333 15.3562 14.0833 14.625 15 14.625C15.9167 14.625 16.6667 15.3562 16.6667 16.25C16.6667 17.1437 15.9167 17.875 15 17.875ZM15 13C14.0833 13 13.3333 12.2688 13.3333 11.375C13.3333 10.4812 14.0833 9.75 15 9.75C15.9167 9.75 16.6667 10.4812 16.6667 11.375C16.6667 12.2688 15.9167 13 15 13ZM16.6667 7.3125C16.6667 7.8 16.3333 8.125 15.8333 8.125H4.16667C3.66667 8.125 3.33333 7.8 3.33333 7.3125V4.0625C3.33333 3.575 3.66667 3.25 4.16667 3.25H15.8333C16.3333 3.25 16.6667 3.575 16.6667 4.0625V7.3125Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("simulations") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(permissionsConstants.VIEW_PROJECT) ||
                    allowedComponentMap.get(
                      permissionsConstants.VIEW_SIMULATION
                    )
                "
              >
                <b-link
                  @click="toggleSidebar()"
                  :to="{ name: 'Operations' }"
                  :class="[{ active: $route.path.startsWith('/operations') }]"
                  class="nav-link works-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="25" height="27" viewBox="0 0 25 27" fill="none">
                      <defs>
                        <mask
                          id="checkMask"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="25"
                          height="27"
                        >
                          <rect width="25" height="27" fill="white" />
                          <g
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            fill="none"
                          >
                            <path
                              d=" M5 6.5 L6.5 8 L9 5 M11 6.5 H19 M5 11.5 L6.5 13 L9 10 M11 11.5 H19 M5 16.5 L6.5 18 L9 15 M11 16.5 H19 "
                            />
                          </g>
                        </mask>
                      </defs>
                      <path
                        d="M1.5 1.5H22.5V22.5H1.5Z"
                        fill="#132D48"
                        mask="url(#checkMask)"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("operations") }}</span>
                </b-link>
              </li>
              <li class="nav-item">
                <b-link
                  :to="{ name: 'Reporting' }"
                  :class="[
                    { active: $route.path.split('/').includes('reporting') }
                  ]"
                  @click="toggleSidebar()"
                  class="nav-link reporting-link"
                  href="#"
                >
                  <span class="icon">
                    <svg width="29" height="27" viewBox="0 0 29 27" fill="none">
                      <path
                        d="M2.20745 17.189C2.04794 17.2346 1.88844 17.2573 1.72893 17.2801C1.4327 17.3257 1.20483 17.5764 1.20483 17.8954V25.8707C1.20483 26.1898 1.45549 26.4404 1.7745 26.4404H5.71661C6.03563 26.4404 6.28628 26.1898 6.28628 25.8707V15.5939C6.28628 15.4572 6.12677 15.3888 6.03563 15.48C5.26088 16.1636 3.02777 16.9383 2.20745 17.189Z"
                        fill="#132D48"
                      />
                      <path
                        d="M10.0006 8.68956L8.42827 10.2846C8.31433 10.3986 8.24597 10.5581 8.24597 10.7176V25.8708C8.24597 26.1898 8.49663 26.4404 8.81564 26.4404H12.7578C13.0768 26.4404 13.3274 26.1898 13.3274 25.8708V9.53267C13.3274 9.37317 13.2591 9.21366 13.1451 9.09972L12.735 8.68956C12.5982 8.55284 12.3704 8.48448 12.1881 8.50727C11.664 8.6212 11.1171 8.6212 10.593 8.50727C10.3424 8.46169 10.1373 8.53005 10.0006 8.68956Z"
                        fill="#132D48"
                      />
                      <path
                        d="M15.2643 25.8708C15.2643 26.1898 15.5149 26.4404 15.834 26.4404H19.7761C20.0951 26.4404 20.3457 26.1898 20.3457 25.8708V15.3888C20.3457 14.9559 19.89 14.6369 19.5026 14.7964C18.2266 15.3205 16.7454 15.161 15.5833 14.3407C15.4466 14.2495 15.2643 14.3407 15.2643 14.5002V25.8708Z"
                        fill="#132D48"
                      />
                      <path
                        d="M24.5613 7.20834L22.4877 9.28194C22.3738 9.39587 22.3054 9.55538 22.3054 9.71488V25.8479C22.3054 26.1669 22.5561 26.4176 22.8751 26.4176H26.8172C27.1362 26.4176 27.3869 26.1669 27.3869 25.8479V7.66408C27.3869 7.2767 27.0223 6.98047 26.6349 7.04883C26.1336 7.13998 25.6323 7.11719 25.131 7.02605C24.9031 7.00326 24.698 7.07162 24.5613 7.20834Z"
                        fill="#132D48"
                      />
                      <path
                        d="M25.9057 0.372314C24.4474 0.372314 23.2625 1.55723 23.2625 3.01558C23.2625 3.53967 23.422 4.04098 23.6954 4.47393L19.3659 8.80341C18.4772 8.21096 17.3151 8.23375 16.4264 8.8262L13.5553 5.93228C14.3528 4.7018 14.011 3.06115 12.7806 2.26362C11.5501 1.46608 9.90942 1.80788 9.11188 3.03837C8.54221 3.92705 8.54221 5.0436 9.11188 5.93228L4.09879 11.0365C2.86831 10.239 1.22766 10.5808 0.430127 11.8113C-0.36741 13.0418 -0.0256085 14.6824 1.20488 15.4799C2.43536 16.2775 4.07601 15.9357 4.87355 14.7052C5.44321 13.8165 5.44321 12.7 4.87355 11.8113L9.90942 6.70703C10.7753 7.2767 11.9147 7.2767 12.8033 6.70703L15.6973 9.60095C14.9225 10.8314 15.3099 12.4721 16.5404 13.2468C17.7709 14.0216 19.4115 13.6342 20.1862 12.4037C20.7331 11.5378 20.7103 10.4213 20.1635 9.55538L24.4929 5.22589C25.7234 6.02343 27.3641 5.68163 28.1616 4.45114C28.9592 3.22066 28.6174 1.58001 27.3869 0.782476C26.9311 0.531822 26.4298 0.372314 25.9057 0.372314Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("reporting") }}</span>
                </b-link>
              </li>
              <li class="nav-item">
                <b-link
                  :to="{ name: 'Reglementaire' }"
                  :class="[
                    { active: $route.path.split('/').includes('reglementaire') }
                  ]"
                  @click="toggleSidebar()"
                  class="nav-link reglementaire-link"
                  href="#"
                >
                  <span class="icon">
                    <svg
                      width="21"
                      height="25"
                      viewBox="0 0 21 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.9227 4.54441C20.9069 3.83249 20.4168 3.62683 19.7845 3.62683C16.5123 3.57937 13.5879 2.61432 11.1693 0.320363C10.7109 -0.106788 10.2367 -0.106788 9.79407 0.320363C7.35969 2.61432 4.43527 3.57936 1.16309 3.61101C0.32528 3.62683 0.0091269 4.05398 0.0091269 4.845C0.0249346 5.98407 0.0091269 7.12313 0.0091269 8.2622C0.0407422 8.2622 -0.0224884 8.2622 0.0091269 8.2622C0.0723576 9.49619 0.0249344 10.7302 0.11978 11.9642C0.609818 18.2765 3.75554 22.5955 9.73084 24.7945C10.0944 24.9211 10.4422 25.0951 10.8532 24.9369C15.2951 23.3074 18.678 20.6021 20.0691 15.8876C21.1914 12.1698 21.0333 8.35713 20.9227 4.54441ZM14.4415 10.9991C13.003 12.423 11.5803 13.8468 10.1576 15.2865C9.90472 15.5396 9.6518 15.7927 9.25661 15.8085C8.70334 15.8085 5.98442 13.04 5.98442 12.5021C5.98442 12.1698 6.15831 11.9167 6.41123 11.7743C6.74319 11.5845 7.10677 11.6003 7.40711 11.8693C7.83392 12.2648 8.29234 12.6445 8.65592 13.1032C9.08273 13.6095 9.35146 13.657 9.84149 13.1349C10.9164 11.9642 12.0862 10.8726 13.2085 9.7335C13.6511 9.29053 14.1412 8.91084 14.7103 9.49619C15.2635 10.0657 14.8841 10.5562 14.4415 10.9991Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("reglementaire") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(permissionsConstants.VIEW_CONTRACT)
                "
              >
                <b-link
                  :to="{ name: 'Contracts' }"
                  :class="[
                    { active: $route.path.split('/').includes('contracts') }
                  ]"
                  @click="toggleSidebar()"
                  class="nav-link contracts-link"
                  href="#"
                >
                  <span class="icon">
                    <svg
                      width="21"
                      height="25"
                      viewBox="0 0 21 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1725_93)">
                        <path
                          d="M4.49229 9.24231C4.82143 9.24231 5.0883 8.97799 5.0883 8.652V4.58151L0.57373 9.24231H4.49229Z"
                          fill="#132D48"
                        />
                        <path
                          d="M11.1107 4.07488C11.1107 4.03964 11.1152 3.99999 11.1152 3.96475H6.26702C6.28036 3.99999 6.28481 4.03964 6.28926 4.07488V8.65198C6.28926 9.63436 5.4842 10.4317 4.49233 10.4317H0V23.8238C0 24.4758 0.533742 25 1.18758 25H16.0612C16.7195 25 17.2488 24.4714 17.2488 23.8238V9.26431C14.3754 9.73568 11.6534 7.81057 11.1774 4.96475C11.1285 4.6696 11.1063 4.37004 11.1063 4.07048L11.1107 4.07488ZM10.3146 21.8943H8.54432C7.548 21.8943 6.71625 21.1454 6.6184 20.1674L4.17653 21.7929C3.90076 21.978 3.52714 21.9031 3.34478 21.6299C3.15797 21.3568 3.23359 20.9868 3.50935 20.8062L6.2003 19.0132C6.67177 18.696 7.31671 18.8194 7.63696 19.2907C7.7526 19.4581 7.81487 19.6608 7.81487 19.8634V19.978C7.81487 20.3788 8.14401 20.7048 8.54876 20.7048H10.319C10.6526 20.696 10.9239 20.9559 10.9328 21.2863C10.9417 21.6167 10.6793 21.8855 10.3457 21.8943C10.3368 21.8943 10.3279 21.8943 10.3146 21.8943ZM10.3146 16.6696H3.38036C3.04678 16.6608 2.78435 16.3877 2.79325 16.0617C2.80214 15.7445 3.06012 15.489 3.38036 15.4802H10.3146C10.6481 15.489 10.9106 15.7621 10.9017 16.0881C10.8928 16.4053 10.6348 16.6608 10.3146 16.6696ZM13.6593 21.8943H12.7475C12.4139 21.8855 12.156 21.6123 12.1604 21.2863C12.1693 20.9692 12.4273 20.7137 12.7475 20.7048H13.6593C13.9929 20.7137 14.2509 20.9868 14.2465 21.3128C14.2376 21.63 13.9796 21.8855 13.6593 21.8943ZM13.6593 13.9075H3.38036C3.04678 13.8987 2.7888 13.6255 2.79325 13.2996C2.80214 12.9824 3.06012 12.7269 3.38036 12.7181H13.6593C13.9929 12.7269 14.2509 13 14.2465 13.326C14.2376 13.6432 13.9796 13.8987 13.6593 13.9075Z"
                          fill="#132D48"
                        />
                        <path
                          d="M16.4258 0C14.1529 0 12.3115 1.82379 12.3115 4.07489C12.3115 6.32599 14.1529 8.14978 16.4258 8.14978C18.6986 8.14978 20.54 6.32599 20.54 4.07489C20.5356 1.82379 18.6942 0 16.4258 0ZM18.7742 3.14537L16.4258 5.82819C16.3101 5.96035 16.1456 6.03524 15.9721 6.03524C15.7986 6.03524 15.6296 5.96035 15.5184 5.82819L14.4109 4.55066C14.193 4.29956 14.2241 3.92511 14.4776 3.71366C14.7312 3.4978 15.1092 3.52863 15.3227 3.77974L15.9765 4.53304L17.8669 2.37004C18.0848 2.12335 18.4629 2.09692 18.712 2.30837C18.9611 2.52423 18.9877 2.89868 18.7742 3.14537Z"
                          fill="#132D48"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1725_93">
                          <rect width="20.5357" height="25" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <span>{{ $t("contracts") }}</span>
                </b-link>
              </li>
              <li class="nav-item">
                <b-link
                  :to="{ name: 'Contacts' }"
                  :class="[{ active: $route.name == 'Contacts' }]"
                  @click="toggleSidebar()"
                  class="nav-link contacts-link"
                  href="#"
                >
                  <span class="icon">
                    <svg
                      width="22"
                      height="25"
                      viewBox="0 0 22 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.5556 0H2.44444C1.1 0 0 1.125 0 2.5V22.5C0 23.875 1.1 25 2.44444 25H19.5556C20.9 25 22 23.875 22 22.5V2.5C22 1.125 20.9 0 19.5556 0ZM11 7.5C12.3444 7.5 13.4444 8.625 13.4444 10C13.4444 11.375 12.3444 12.5 11 12.5C9.65556 12.5 8.55556 11.375 8.55556 10C8.55556 8.625 9.65556 7.5 11 7.5ZM15.2778 17.5H6.72222C6.72222 16.375 7.21111 15.3125 8.12778 14.625C8.8 14.125 9.71667 13.75 11 13.75C12.2833 13.75 13.2 14.1875 13.8722 14.625C14.7889 15.3125 15.2778 16.375 15.2778 17.5Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("contacts") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(
                    permissionsConstants.MANAGE_AGENCES
                  ) && userInfo.clientType === 'B2B2B'
                "
              >
                <b-link
                  :to="{ name: 'Agences' }"
                  :class="[{ active: $route.matched[0].name === 'Agences' }]"
                  @click="toggleSidebar()"
                  class="nav-link contacts-link"
                  href="#"
                >
                  <span class="icon">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="3g1sn45bda"
                        style="mask-type:alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="27"
                        height="27"
                      >
                        <path fill="#D9D9D9" d="M0 0h27v27H0z" />
                      </mask>
                      <g mask="url(#3g1sn45bda)">
                        <path
                          d="M2.25 23.625V3.375H13.5v4.5h11.25v15.75H2.25zm2.25-2.25h2.25v-2.25H4.5v2.25zm0-4.5h2.25v-2.25H4.5v2.25zm0-4.5h2.25v-2.25H4.5v2.25zm0-4.5h2.25v-2.25H4.5v2.25zm4.5 13.5h2.25v-2.25H9v2.25zm0-4.5h2.25v-2.25H9v2.25zm0-4.5h2.25v-2.25H9v2.25zm0-4.5h2.25v-2.25H9v2.25zm4.5 13.5h9v-11.25h-9v2.25h2.25v2.25H13.5v2.25h2.25v2.25H13.5v2.25zm4.5-6.75v-2.25h2.25v2.25H18zm0 4.5v-2.25h2.25v2.25H18z"
                          fill="#132D48"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>{{ $t("agences") }}</span>
                </b-link>
              </li>
              <li
                class="nav-item"
                v-if="
                  allowedComponentMap.get(permissionsConstants.MANAGE_USERS)
                "
              >
                <b-link
                  :to="{ name: 'Team' }"
                  :class="[{ active: $route.matched[0].name === 'Team' }]"
                  @click="toggleSidebar()"
                  class="nav-link contacts-link"
                  href="#"
                >
                  <span class="icon">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.5625 15.75C16.875 15.75 15.525 16.2 14.5125 16.7625C16.0875 18.1125 16.7625 19.6875 16.875 19.8L16.9875 20.025V22.5H25.9875V20.25C25.875 20.25 24.075 15.75 18.5625 15.75Z"
                        fill="#132D48"
                      />
                      <path
                        d="M18.5625 13.5C20.7371 13.5 22.5 11.7371 22.5 9.5625C22.5 7.38788 20.7371 5.625 18.5625 5.625C16.3879 5.625 14.625 7.38788 14.625 9.5625C14.625 11.7371 16.3879 13.5 18.5625 13.5Z"
                        fill="#132D48"
                      />
                      <path
                        d="M4.5 9.5625C4.5 7.425 6.3 5.625 8.4375 5.625C10.575 5.625 12.375 7.425 12.375 9.5625C12.375 11.7 10.575 13.5 8.4375 13.5C6.3 13.5 4.5 11.7 4.5 9.5625ZM8.4375 15.75C2.925 15.75 1.125 20.25 1.125 20.25V22.5H15.75V20.25C15.75 20.25 13.95 15.75 8.4375 15.75Z"
                        fill="#132D48"
                      />
                    </svg>
                  </span>
                  <span>{{ $t("users") }}</span>
                </b-link>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="enableHelpDesk" class="giga-helpDesk">
          <img src="../../assets/images/help-icon.svg" alt="" />
          <span>Besoin d'aide?</span>
        </div>
        <div class="giga-legal-notice">
          <span>
            <img src="@/assets/images/legal-documents.svg" alt="avatar" />
            <a
              href="/documents/legal_notices_GWT.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Mentions légales
            </a>
          </span>
        </div>
      </div>
    </div>
    <user-config
      :userForm="userForm"
      :$v="$v"
      fontSize="h3"
      backdrop-close="false"
      @confirmClick="onUserConfigConfirm()"
    ></user-config>
    <user-agence font-size="h3" backdrop-close="false"> </user-agence>
    <ReleaseNote
      v-if="showReleasePopup"
      :note="releaseNoteData"
      @close="onReleaseClose"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { constants } from "@/shared/constants";
import { helpers } from "@/shared/helper";
import { account } from "../../store/account.module";
import store from "@/store";
import UserConfig from "@/views/Account/NewUser/UserConfig.vue";
import { email, required } from "vuelidate/lib/validators";
import { userService } from "@/views/service/user.service";
import ReleaseNote from "../../views/Release/ReleaseNote.vue";
import UserAgence from "@/views/Account/UserAgence.vue";
import releaseService, {
  releaseNoteData
} from "../../views/Release/service/release.service";

export default {
  name: "LeftSidebar",
  components: { UserAgence, UserConfig, ReleaseNote },
  created() {
    releaseService
      .getReleaseNotes()
      .then(data => {
        this.currentVersion = data.version;
        const lastSeen = localStorage.getItem("gwt_last_seen_version");
        this.showReleasePopup = lastSeen !== this.currentVersion;
      })
      .catch(() => {
        this.showReleasePopup = false;
      });
  },
  async mounted() {
    if (!this.loggedIn) return;

    await this.userInfoAction();
    this.allowedComponentMap = helpers.allowedComponent();
    this.notificationTimer();
    this.handleModalsIfNeeded();
  },
  data() {
    return {
      enableHelpDesk: false,
      scrollBarSettings: {
        scrollXMarginOffset: 50
      },
      permissionsConstants: constants,
      allowedComponentMap: null,
      userForm: {
        lastName: "",
        firstName: "",
        email: ""
      },
      showReleasePopup: true,
      releaseNoteData: releaseNoteData,
      USER_TYPE: constants.USER_TYPE,
      ROLE_TYPE: constants.ROLE_TYPE,
      currentVersion: ""
    };
  },
  validations() {
    return {
      userForm: {
        lastName: { required },
        firstName: { required },
        email: {
          required,
          email
        },
        agence: {},
        phoneNumber: {
          phone: constants.phonePattern
        }
      }
    };
  },
  computed: {
    ...mapGetters("leftsidebar", [
      "getSidebarShowStatus",
      "getHasHeaderStatus"
    ]),
    ...mapGetters("notification", {
      notificationCounters: "getNotificationCounters"
    }),
    ...mapGetters("account", {
      userInfo: "getCurrentUser",
      loggedIn: "loggedIn"
    })
  },
  methods: {
    ...mapActions("notification", [
      "getNotificationCountersAction",
      "openModal",
      "closeModal"
    ]),
    ...mapActions("account", ["userInfoAction", "logoutAction"]),
    ...mapMutations({
      toggleSidebar: "leftsidebar/toggleSidebar"
    }),
    // get number of not read notification every 15 minutes
    notificationTimer() {
      this.getNotificationCountersAction();
      const callBackFrequency = 900000;
      setInterval(() => {
        this.getNotificationCountersAction();
      }, callBackFrequency);
    },
    getAllowedComponents() {
      setTimeout(() => {
        this.allowedComponentMap = helpers.allowedComponent();
      }, 500);
    },

    onUserConfigConfirm() {
      const data = {
        id: this.userForm.id,
        lastName: this.userForm.lastName,
        firstName: this.userForm.firstName,
        email: this.userForm.email,
        phoneNumber: this.userForm.phoneNumber
      };
      userService.modifyUserConfig(data).then(() => {
        this.closeModalUser();
        this.userForm = {
          lastName: "",
          firstName: "",
          email: ""
        };
      });
    },
    closeModalUser() {
      this.closeModal({ instance: this.$root, id: "editAccountName" });
      this.userForm = {
        lastName: "",
        firstName: "",
        email: ""
      };
    },
    doOpenUserModal(modelId) {
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: modelId });
      }, 1);
    },
    onReleaseClose() {
      localStorage.setItem("gwt_last_seen_version", this.currentVersion);
      this.showReleasePopup = false;
    },
    async handleModalsIfNeeded() {
      const currentUser = this.$store.getters["account/getCurrentUser"];
      const isImpersonate = this.$store.getters["account/getImpersonate"];

      if (!isImpersonate && (!currentUser.lastName || !currentUser.firstName)) {
        Object.assign(this.userForm, {
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          email: currentUser.email
        });
        this.doOpenUserModal("editAccountName");
      }
    }
  }
};
</script>
<style lang="scss">
.view-area-sidebar {
  height: 100vh;
  overflow-y: auto;
}
.giga-legal-notice {
  padding: 12px 30px;
  display: flex;
  align-items: center;
  @media (max-width: 1440px) {
    padding: 12px 20px;
  }
  a {
    font-size: 18px;
    font-weight: 700;
    color: #6cbe3e;
    @media (max-width: 1440px) {
      font-size: 18px;
    }
  }
  img {
    margin-right: 18px;
    height: 35px;
  }
}
</style>
